(function() {
  window.SideCart = window.SideCart || new function() {
    //runs once per page load
    var self = this;
    var isOpen = false;

    document.addEventListener('mousedown', function(event){
      var sideCart = document.getElementById('side-cart');
      if(!sideCart || (!event.target.closest('#side-cart') && event.target.id!="loading-overlay" && sideCart.classList.contains('open') && !event.target.classList.contains('tingle-modal') && !event.target.closest('.tingle-modal'))) {
        self.hideSideCart();
      }
    });

    self.updateSideCart = function(open) {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=side_cart', success: function(data){
        var section = document.querySelector('#side-cart');
        $s.updateDynamicContent(section, data['side_cart']);
        var foot = document.querySelector('#side-cart .foot');
        if (section.querySelector('.cart-items')) {
          foot.style.display = '';
        } else {
          foot.style.display = 'none';
        }
        self.openAfterUpdate = open;
        $s.globalEval(data['side_cart']);
      
        //ensure scroll to top after update
        setTimeout(()=>{
          var wrapItems = section.querySelector('.wrap');
          wrapItems.scrollTop = 0;
        },50)

        $s.hideLoadingOverlay(); //trigger before showSideCart to handle focus properly
        if (open) {
          self.showSideCart(!isOpen);
        }
      }});

      console.log("updated");
    }

    self.showSideCart = function(animate) {
      var sideCart = document.getElementById('side-cart');
      var activeElement = null;
      if (isOpen) {
        if (sideCart.contains(document.activeElement)) {
          activeElement = document.activeElement;
        }
        $s.removeTrapFocus();
      }
      $s.closeModal();

      isOpen = true;
      
      $s.showOverlay()
      if(animate) {
        setTimeout(function(){
          sideCart.classList.add('open'); 
          setTimeout(function() {
            $s.trapFocus(sideCart, activeElement);
          }, 50);
        }, 100);
      } else {
        sideCart.classList.remove('ease-animation-slow');
        sideCart.classList.add('open');
        setTimeout(function(){sideCart.classList.add('ease-animation-slow')}, 200);
        $s.trapFocus(sideCart, activeElement);
      }
    };

    self.hideSideCart = function() {
      isOpen = false;
      var sideCart = document.getElementById('side-cart');
      $s.hideOverlay();
      sideCart.classList.remove('open');
      $s.removeTrapFocus();
    };

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    self.isOpen = function() {
      return isOpen;
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: async function(cart) {var runResponse = await $s.AutoAddRemoveProducts.runAllRules(JSON.parse(cart), true);$s.addToCartSuccess();
        },
        error: $s.addToCartFail
      });
    }

    window.addEventListener('keydown', function(e){
      if (e.which == 27) { //Exit
        var sideCart = document.getElementById('side-cart');
        if(sideCart.classList.contains('open')){
          e.preventDefault();
          window.SideCart.hideSideCart();
          return false;
        }
      }
    });

    
  
    self.cartCount = function() {
      var sideCart = document.getElementById('side-cart');
      var itemsCount = 0;
      sideCart.querySelectorAll('.cart-items .item .quantity-box input[type=number]').forEach(function(item){
        itemsCount += item.value/1;
      });
      var cartCountElement = document.querySelector('header .cart-count');
      if(cartCountElement) {
        cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
        document.querySelectorAll('#side-cart .qty-checker').forEach(x=>x.innerHTML = itemsCount>0?itemsCount:'');
      }
        
    }
  };


  //runs every time #side-cart div is replaced
  //WARNING: below here only run events to elements inside [data-dynamic-content] elements
  var sideCart = document.getElementById('side-cart');
  window.SideCart.cartCount();

  sideCart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      SideCart.updateItemsQuantity([this.closest('.item')], 0);
    });
  });

  sideCart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      SideCart.updateItemsQuantity([this.closest('.item')], this.value);
    });
  });var checkInstructions = document.getElementById('sidecart-chk-instructions');
  if (checkInstructions) {
    var checkInstructionsChange = function() {
      var note = document.getElementById('sidecart-instructions-note');
      if (checkInstructions.checked) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkInstructions.click();
      }
    });
    checkInstructions.addEventListener('click', checkInstructionsChange);
    checkInstructionsChange();
  }if(typeof _swat == 'object') _swat.initializeActionButtons('#side-cart');

  // Keep Shopping Button
  var keepShopping = document.querySelector('#side-cart .close-cart')
  if(keepShopping){
    keepShopping.addEventListener('click', function (e) {
      window.SideCart.hideSideCart()
    })
  }
})();